import React, {Fragment, useState} from "react";
import {Link} from "gatsby";
import {Button, Col, Row} from "antd";
import {colors, getImage} from "../helper/helper";
import ProfileGroupIcon from "../assets/images/Profile-Group-icon.png";
import IndividualIcon from "../assets/images/Individual-icon.png";
import PlaceHolderImg from "../assets/images/image-placeholder.png";
import CourseImage from "../assets/images/Main-Graphic@3x.png";
import SkillCoaching from "../assets/images/onDemandCoaching.png";
import SelfHelpImage from "../assets/images/Self-Health-Coach-Section.png";
import BehavioralImg from "../assets/images/Behavioural-Graphic@3x.png";
import ScienceImg from "../assets/images/Science-Graphic@3x.png";
import HowDoesWorkImg from "../assets/images/howdoesitwork-Graphic@3x.png";
import WhatCanIGetImg from "../assets/images/whatcaniget-Graphic@3x.png";
import TransformSection from "../assets/images/transform-section-bg.png";
import CTAButton from "../assets/images/CTA-btn.png";
import MentalHealth from "../assets/images/Mental Health-bg@3x.png";
import PersonalGrowth from "../assets/images/Personal Growth-bg@3x.png";
import PersonalityBG from "../assets/images/Personality-bg@3x.png";
import RelationBG from "../assets/images/Relationship-bg@3x.png";
import UserImg from "../assets/images/5@3x.png";
import Quote from "../assets/images/quote-icon@3x.png";
import DurationIcon from "../assets/images/duration.png";
import {getProgramName} from "../shared";

if (typeof window === 'undefined') {
  global.window = {
    location: {}
  }
}
const LifeCoachClient = (props) => {
  const [showAll, setShowAll] = useState(false);
  const [section, setSection] = useState(-1);
  const [testimonial, setTestimonial] = useState(-1);

  // const getImage = async img => {
  //   Storage.configure({
  //     Auth: {
  //       identityPoolId: "us-east-1:a8461efd-7716-46ed-a48f-9093a2de1be9", //REQUIRED - Amazon Cognito Identity Pool ID
  //       region: 'us-east-1', // REQUIRED - Amazon Cognito Region
  //       userPoolId: "us-east-1_DjQM1dBnA",
  //       userPoolWebClientId: "jdnl0bq8hins00nq7bmthmdm9"
  //     },
  //     AWSS3: {
  //       bucket: "coachingapp-userfiles-mobilehub-1299275089", // REQUIRED -  Amazon S3 bucket
  //       region: 'us-east-1', // OPTIONAL -  Amazon service region
  //     },
  //   });
  //   try{
  //   const profileImage = await Storage.get(img, {level: "public"});
  //     console.log(profileImage)
  //     return profileImage;
  //     }catch (e) {
  //     console.log(e)
  //   }
  //
  // }
  const handleSectionClick = (id) => {
    setSection(section === id ? -1 : id)
  };

  const handleTestimonial = (id) => {
    setTestimonial(testimonial === id ? -1 : id)
  };

  const data = [
    {
      img: BehavioralImg,
      title: 'Holistic Behavioral Health',
      desc: 'Programs for specific conditions designed by marrying Technology & Evidence-Based Therapies - taking into account overall health (Mental, Physical, Social, Nutrition, etc.) rather than just symptoms. These programs are delivered by Licensed Psychologists and Certified Behavioral Health Coaches.',
    }, {
      img: ScienceImg,
      title: 'What is the Science?',
      desc: 'Behavioral Health coaching is based on research and evidence, you and your coach will use a proven system that significantly increases your chance of implementing behavioral changes that last a lifetime. Your coaches will tap into evidence-based treatment modalities such as Dialectical Behavior Therapy (DBT), Cognitive Behavioral Therapy (CBT), ACT etc. and Mindfulness Exercises. Together, you’ll assess your issues and determine the best plan of action, which may include referrals and coordination of care with other community resources.',
    }, {
      img: HowDoesWorkImg,
      title: 'How does it work?',
      desc: 'Our coaches use the principles of evidence-based therapies to assist clients in altering their actions, reactions, and behavioral patterns. Using our platform, coaches can get a holistic view of their clients - mental, emotional, physical, nutrition, bio-feedback etc. This allows them to provide tailored treatment that leads to better outcomes.',
    }, {
      img: WhatCanIGetImg,
      title: 'What can I get help with?',
      desc: <>Our coaches can help you in many aspects of your life that affect your overall well being, behavior including:
        <br />
        <ul className='hide-ul'>
          <li>Work-life balance</li>
          <li>Emotional support</li>
          <li>Spirituality wellness</li>
          <li>Caregiver support</li>
          <li>Anger management</li>
          <li>Substance abuse</li>
          <li>Work-life balance</li>
          <li>Emotional support</li>
          <li>Spirituality wellness</li>
          <li>Caregiver support</li>
          <li>Anger management</li>
          <li>Substance abuse</li>
          <li>Mental health and lifestyle</li>
          <li>Eating disorders</li>
          <li>Depression, anxiety, </li>
          <li>Alcohol use</li>
          <li>Gender identity, sexuality</li>
          <li>Sex life</li>
          <li>Relationships – family, friends</li>
          <li>Mindfulness and meditation</li>
          <li>ADHD</li>
          <li>Bipolar disorder</li>
          <li>Cognitive behavioral therapy</li>
          <li>Dialectical behavioral therapy</li>
          <li>Acceptance & Commitment therapy</li>
          <li>Parenting skill</li>
          <li>Personality disorder</li>
        </ul>
      </>
    }];
  const testimonials = [
    {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }, {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }, {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }, {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }, {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }, {
      img: Quote,
      user: UserImg,
      desc: 'Life Coaching with Michele changed my life. I was at a standstill for over 10 years working a Corporate job I didnt like. After 1 month of working with her I found a school to attend, my confidence increased in making a decision and I was able to move forward. I ended taking the package from Corporate and now I have the job of my dreams. I am a Holistic Health Counselor. I see clients privately and I do cooking classes and seminars. I never imagined what working with Michele would have done. A great experience but also a necessary one to make things happen in my life. I cannot thank her enough.    ',
    }];
  const programsData = !showAll ? props.programs?.slice(0, 6) : props.programs;
  return (
    <Fragment>
      <section className='home-section-group client-section-group'>
        <Row className='card-row -row-flex col-reverse' style={{ marginBottom: '5rem' }} gutter={16}>
          <Col md={10} className='card-col -margin-right -margin-bottom'>
            <h2 className='margin-bottom-10 base-text' style={{ color: "black" }}>
              Evidence-Based Behavioral Health Coaching
            </h2>
            <div className='subtitle para-text' style={{ color: '#4F4F4F' }}>
              Whenever you happen to be in life, whatever challanges you face, we have life changing Programs, Coaches
              and other resources to help you tap into your full potential
              so you can start building a life worth living.
            </div>
            <p className='watch-video-info'>
              {/*<Link to='/download' className='para-text watch-video-adv'>
                <span>Watch Video</span>
                <img src={VideoButton} />
              </Link>*/}
              <Button style={{ marginTop: 30 }} className='coaching-primary-orange-btn'>
                <Link to={'/coach'} className="base-text">I am a Coach</Link>
              </Button>
            </p>
          </Col>
          <Col md={12} className='card-col image-col' style={{ transform: 'translateY(-8%)' }}>
            <img src={CourseImage} />
          </Col>
        </Row>
        <Row gutter={24} className='second-fold-row' style={{ transform: 'translateY(-8%)' }}>
          <img src={TransformSection} className='transform-section-img' />
          <div className='cell well second-fold-bg' style={{ padding: '50px 0' }}>
            <div className='grid grid--4col well--m mt4 pricing-relative'>
              {data?.map((item, i) =>
                <div
                  className={`card card--vertical
                  card--starter pricing-relative
                  life-coach-grid-section
                  `}
                  style={window.innerWidth > 600 ? { marginTop: i % 2 !== 0 ? -30 : 0} : null }
                >
                  <div className='card-text' style={{flexDirection: "column",justifyContent: "space-between"}}>
                    <div>
                    <img src={item.img} />
                    <h5 className='base-text'>{item.title}</h5>
                    </div>
                    <p className='para-text line-clamp-para'>{item.desc}</p>
                    {/*  <Tooltip trigger='click' overlayClassName='tooltip-overlay-details' title={
                      <div className='card card--vertical card--starter pricing-relative life-coach-grid-section'>
                        <div className='card-text'>
                          <img src={item.img}/>
                          <h5 className='base-text'>{item.title}</h5>
                          <p className='para-text'>{item.desc}</p>
                        </div>
                      </div>
                    }>*/}
                    {/*<a className='para-text more-link-text' onClick={() => handleSectionClick(i)}>{i === section ? 'SHOW LESS' :'LEARN MORE'}</a>*/}
                    {/*</Tooltip>*/}
                  </div>
                </div>)}
            </div>
          </div>
          <Row className='card-row -margin-bottom -row-flex divider col-reverse feature-collection' style={{ marginRight: 5, marginLeft: 0 }} gutter={16}>
            <Col md={10} className='card-col -margin-right -margin-bottom'>
              <h2 className='navy-text margin-bottom-25 base-text'>Are you ready to transform your life?</h2>
              <div className='subtitle para-text'>
                You know yourself better than anyone. Sometimes answers to your questions are hidden within.
                Your coaching session will help you find key to unlock the door to realization of inner knowledge.
              </div>
              <p>
                <Link to='/download' className='base-text watch-video-adv'><span>GET STARTED</span> <img src={CTAButton} /></Link>
              </p>
            </Col>
            <Col md={12} className='card-col feature-collection_nav' style={{ transform: 'translateY(-8%)', padding: 0 }}>
              <Row className='feature-collection_nav_item'>
                <div>
                  <img src={MentalHealth} />
                  <p>
                    <h2 className='base-text'>Mental Health</h2>
                    <h4 className='para-text'>Collection - 5 Programs</h4>
                  </p>
                </div>
              </Row>
              <Row className='feature-collection_nav_item'>
                <div>
                  <img src={PersonalityBG} />
                  <p>
                    <h2 className='base-text'>Personality</h2>
                    <h4 className='para-text'>Collection - 5 Programs</h4>
                  </p>
                </div>
              </Row>
              <Row className='feature-collection_nav_item'>
                <div>
                  <img src={PersonalGrowth} />
                  <p>
                    <h2 className='base-text'>Personal Growth</h2>
                    <h4 className='para-text'>Collection - 5 Programs</h4>
                  </p>
                </div>
              </Row>
              <Row className='feature-collection_nav_item'>
                <div>
                  <img src={RelationBG} />
                  <p>
                    <h2 className='base-text'>Relationship</h2>
                    <h4 className='para-text'>Collection - 5 Programs</h4>
                  </p>
                </div>
              </Row>
            </Col>
          </Row>
        </Row>
        <Row className='card-row -margin-bottom -row-flex col-reverse online-coaching' gutter={16}>
          <Col md={16} className='card-col image-col'>
            <div className='cell well' style={{ paddingRight: '20px' }}>
              <div className='grid grid--3col well--m mt4 online-coaching-details'>
                {programsData?.map(item =>
                  <Link to={`/program/${getProgramName(item?.name)}?programId=${item.id}`} className="slider__item">
                    <a
                      className="stream-card-v3 stream-card-v3--small stream-card-v3--light-orange d-flex align-items-end"
                      tabIndex={0}
                    >
                      <div className="stream-card-v3__content d-flex align-items-start flex-column w-100">
                        <div className="content__container">
                            <div style={{display: "flex",flexWrap:"wrap"}}>
                              {item.tags?.length ? item.tags.map((tag, i) =>
                                  <p className={`program-tags ${colors[i % 3]}`}>
                                    {tag}
                                  </p>
                              ) : ""}
                            </div>
                          <h4
                            className="content__title mb-1 text-white font-calluna base-text"
                            data-content="Sleep Well"
                            data-max-line={2}
                          >
                            {item.name}
                          </h4>
                          <div style={{display: "flex"}}>
                            <p className="group-individual-info para-text">
                              <img src={item.type === "GROUP" ? ProfileGroupIcon : IndividualIcon } />
                              {item.type}
                            </p>
                            <p className="group-individual-info para-text" style={{marginLeft: 10}}>
                              <img src={DurationIcon} />
                              {`${item?.duration?.interval} ${item?.duration?.period}`}
                            </p>
                          </div>
                          <p
                          className="group-individual-info para-text"
                        >
                            {item.isFree ? "Free" : `$${parseFloat(parseInt(item.payment) / 100)}`}
                          </p>
                          <p
                            className="content__excerpt font-size-md para-text text-white mb-0 font-calluna animated fadeIn faster"
                            data-content="A Guide to Superior Slumber"
                            data-max-line={3}
                          >
                            {item.description || item.shortDescription}
                          </p>
                        </div>
                        <div className="content__owner animated fadeIn faster">
                          <div
                            className="owner__avatar rounded-circle position-relative overflow-hidden">
                            <img
                              style={{ borderRadius: 50, height: 24 }}
                              src={item.coach.picture ? getImage(item.coach.picture) : PlaceHolderImg}
                              className="position-absolute w-100 h-100"
                            />
                          </div>
                          <p
                            className="owner__name base-text text-uppercase text-white font-apercu font-size-sm mb-0"
                            data-content="Hana Otsuka"
                            data-max-line={1}
                          >
                            {item.coach.name}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{ background: !item.image ?
                              `linear-gradient(${item?.gradient?.[0] || "#614385"} , ${item?.gradient?.[1] || "#516395"})`
                          : 'transparent' }}
                        className="stream-card-v3__bg-image rounded position-absolute overflow-hidden">
                        {/*{item.status === "PUBLISHED" ?*/}
                        {/*    <div className='ribbon ribbon-top-right ribbon-green'><span>Enroll</span></div> : null}*/}
                        {item.image ? <img
                          // data-src="https://trickle.app/wp-content/uploads/2020/03/vladislav-muslakov-CwIU33KGToc-unsplash-1024x777.jpg"
                          className="position-absolute w-100 h-100 ls-is-cached lazyloaded"
                          src={getImage(item.image)}
                        /> : null}
                      </div>
                    </a>
                  </Link>
                )}
              </div>
              <div className='explore-programs'>
                <h3 className='navy-text base-text'>
                  Explore all our programs
                </h3>
                {/*{programsData?.length > 6 ?*/}
                <Link to='/programs'>
                <Button className='download-btn base-text' onClick={() => setShowAll(!showAll)}>
                  {showAll ? "Less Programs" : "More Programs"}
                </Button>
                </Link>
                {/*: null}*/}
              </div>
            </div>
          </Col>
          <Col md={8} className='card-col online-coaching-section'>
            <h2 className='navy-text margin-bottom-10 base-text'>Programs grounded in Science</h2>
            <div className='subtitle para-text'>
              <p>
                How do you pursue your dreams and begin living a life you Right Now? How do you tap into more knowledge, intuition, energy, and purpose to fuel your days and give you peaceful rest each night?
                Are you ready to experience healthier and happier relationships, satisfying work, and the joy of knowing you are living your best life?
              </p>

              <p>
                We offer effective care programs designed by clinical experts and grounded in evidence-based practices that are proven to work.
              </p>
              <p>
                We will help you gain insight, take action and experience transformation in your life to have more Presence, Peace and Joy.
              </p>
            </div>
            <p style={{ marginBottom: 0 }}>
              <Link to='/download' className='base-text watch-video-adv'><span>GET STARTED</span> <img src={CTAButton} /></Link>
            </p>
          </Col>
        </Row>
        {/*<Row className='card-row margin-bottom-25 -row-flex divider col-reverse profile-section second-fold-row' gutter={16}>
          <img src={ProfileBg} className='transform-section-img' style={{ height: '40rem' }} />
          <Col md={12} className='card-col -margin-right -margin-bottom'>
            <h2 className='navy-text margin-bottom-25 base-text'>Discover the secret of living life with Passion</h2>
            <div className='subtitle para-text'>
              When you live your life you want to live it to the fullest. You want to feel joy and excitement daily and you want to keep the fire inside of you alive.
            </div>
            <p>
              <Link to='/download' className='base-text watch-video-adv'><span>GET STARTED</span>
                <img src={CTAButton} /></Link>
            </p>
          </Col>
          <Col md={8} className='card-col image-col' style={{ padding: 0 }}>
            <img src={Rectangle2} />
          </Col>
                        </Row>*/}
        <Row className='card-row -margin-bottom -row-flex col-reverse self-help-section' gutter={16}>
          {/*<img src={ProfileBg} className='transform-section-img'/>*/}
          <Col md={12} className='card-col online-coaching-section'>
            <h2 className='navy-text margin-bottom-10 base-text'>Self Help</h2>
            <div className='subtitle para-text'>
              <p>
                You currently enrolled in a Program or have graduated but would like more support or struggling to maintain skill expertise? Are you struggling with a crisis and need help with applying
                the skills? We have you covered.
              </p>
              <p>
                Skills coaching when you need it -  is like taking your learning for a test drive. It further accelerates your
                mastery of these skills.
              </p>
              <p>These sessions include reviewing the weeks' skills used, asking questions, discussing what skills work for
                your specific situation and introducing new  skills to help manage your emotions.
              </p>
              <p>
                Every session is recorded and accessible in the future, so that you can review these sessions when a similar issue comes up.
              </p>
              <p>
                Although skills coaching can be done as needed, clients benefit most from ongoing every other week - coaching for accountability, building trust, and practicing skills.
              </p>
            </div>
            <p style={{ marginBottom: 0 }}>
              <Link to='https://www.resilify.org' className='base-text watch-video-adv'><span>GET STARTED</span> <img src={CTAButton} /></Link>
            </p>
          </Col>
          <Col md={12} className='card-col image-col'>
            <img src={SelfHelpImage} />
          </Col>

        </Row>
        <Row gutter={24} className='second-fold-row' hidden style={{ marginTop: 20 }}>
          <div className='testimonials-title'><h3 className='base-text'>User Testimonials</h3></div>
          <div className='cell well user-testimonial'>
            <div className='grid grid--3col well--m mt4 pricing-relative'>
              {testimonials?.map((item, i) =>
                <div className={`card card--vertical card--starter pricing-relative life-coach-grid-section`}>
                  <div className='card-text'>
                    <img src={item.img} />
                    <p className='para-text navy-text line-clamp-para'>{item.desc}</p>
                    {/*<a className='para-text more-link-text' onClick={() => handleTestimonial(i)}>{i === testimonial ? 'READ LESS' :'READ MORE'}</a>*/}
                    <p className='-font-bold user-img navy-text'><img src={item.user} /> MARK PETER </p>
                  </div>
                </div>)}
            </div>
          </div>
        </Row>
      </section>
    </Fragment>
  )
};

export default LifeCoachClient
